import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerRefundCandidateCounterpartyBankRequest from "./customerRefundCandidateCounterpartyBankRequest";
import RefundPaymentType from "./refundPaymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidateRefundPaymentRequest {
  @observable
  paymentType!: RefundPaymentType;

  @observable
  @Type(() => CustomerRefundCandidateCounterpartyBankRequest)
  counterpartyBank?: CustomerRefundCandidateCounterpartyBankRequest;

  /**
   * PRZ - 1 - 70 T
PRE - 1 - 35 T
   */
  @observable
  counterpartyName?: string;

  /**
   * PRZ 0 - 70 T
PRE 0 - 35 T
   */
  @observable
  counterpartyStreetAddress?: string;

  /**
   * PRZ 0 - 70 T
PRE 0 - 35 T
   */
  @observable
  counterpartyCityAddress?: string;

  @observable
  counterpartyCountryId?: string;

  /**
   * PRZ - T
   */
  @observable
  additionalAvMessage?: string;
}
